//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'

import { TABLET, MOBILE } from '@/scripts/constants/media-query'
import RbBaseEditorialStickyBar from '../base-editorial-sticky-bar/base-editorial-sticky-bar.vue'

import VueScrollTo from 'vue-scrollto'

const { mapGetters: mapGettersHeader } = createNamespacedHelpers('header')
const scrollOffset = 200
export default {
  name: 'rb-anchors-bar',
  extends: RbBaseEditorialStickyBar,
  props: {
    caretIsLight: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'white',
    },
    canBeSticky: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      widthIsGreaterThanContainer: false,
      offsetShimPosition: 167,
      isRightOffsetMax: false,
      isRightOffsetMin: true,
    }
  },
  provide() {
    return {
      color: this.color,
      scrollToElement: (element) => this.scrollToElement(element),
    }
  },
  computed: {
    ...mapGettersHeader(['headerIsCollapsed', 'isStaticHeader']),
    modifierClasses() {
      return {
        [`rb-anchors-bar--${this.color}`]: this.color,
        'rb-anchors-bar--sticky': this.isSticky,
      }
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    caretRight() {
      if (this.caretIsLight) {
        return 'caret-right--light'
      }

      if (this.color === 'white') {
        return 'caret-big-right'
      } else if (this.color === 'black') {
        return 'caret-big-right-light'
      }
      return 'caret-big-right'
    },
    caretLeft() {
      if (this.caretIsLight) {
        return 'caret-left--light'
      }

      if (this.color === 'white') {
        return 'caret-big-left'
      } else if (this.color === 'black') {
        return 'caret-big-left-light'
      }
      return 'caret-big-left'
    },
    inlineStyle() {
      return {
        top: `${this.offsetShimPosition}px`,
      }
    },
  },
  mounted() {
    const container = this.$refs.anchorsBarContainer
    this.widthIsGreaterThanContainer = container?.scrollWidth > container?.offsetWidth
  },
  methods: {
    scrollToElement(element) {
      const options = {
        container: this.$refs.anchorsBarContainer,
        x: true,
        y: false,
        duration: 500,
        offset: -100,
        easing: 'ease',
      }
      VueScrollTo.scrollTo(element.$el, 500, options)
    },
    scrollToDirection(direction) {
      if (direction === 'left') {
        this.$refs.anchorsBarContainer.scrollBy({
          top: 0,
          left: -scrollOffset,
          behavior: 'smooth',
        })
        this.isRightOffsetMax = false
        this.isRightOffsetMin = this.$refs.anchorsBarContainer.scrollLeft - scrollOffset <= 0
      } else if (direction === 'right') {
        this.isRightOffsetMax =
          this.$refs.anchorsBarContainer.offsetWidth +
            this.$refs.anchorsBarContainer.scrollLeft +
            scrollOffset >
          this.$refs.anchorsBarContainer.scrollWidth

        this.$nextTick(() => {
          this.$refs.anchorsBarContainer.scrollBy({
            top: 0,
            left: scrollOffset,
            behavior: 'smooth',
          })
        })

        this.isRightOffsetMin = false
      }
    },
    onScrollCallback() {
      if (this.isMobile) {
        this.offsetShimPosition = 0

        const headerHeight = document.getElementById('rb-header')?.getBoundingClientRect()?.height
        const headerOffset = document.documentElement.style.getPropertyValue('--header-collapsed')
        const parsedHeaderOffset = headerOffset.replace('px', '')
        if (headerHeight && parsedHeaderOffset) {
          this.offsetShimPosition = headerHeight + parseFloat(parsedHeaderOffset)
        }
      } else {
        if (this.isStaticHeader) {
          this.offsetShimPosition = 0
        } else if (this.headerIsCollapsed) {
          this.offsetShimPosition = 118
        } else {
          this.offsetShimPosition = 167
        }
      }
    },
  },
}
